module.exports = __webpack_public_path__ + "static/media/icon-event__el-terrorismo-islamico.fa834c64.svg";